import { type ThemeConfig } from 'antd';

export const rootzzTheme: ThemeConfig = {
  cssVar: true,
  token: {
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#E11D48',
    colorPrimary: '#2B4ACF',
    colorInfo: '#2B4ACF',
    colorLink: '#2B4ACF',
    colorBorder: '#c7c7c7',
    colorBorderSecondary: '#e0e0e0',
    colorBgBase: '#ffffff',
    colorTextBase: '#0F1324',
    colorTextSecondary: 'rgba(15,19,36,0.75)',
    colorTextTertiary: 'rgba(15,19,36,0.55)',
    colorTextQuaternary: 'rgba(15,19,36,0.35)',
    colorBgLayout: '#ffffff',
    colorBgContainer: '#ffffff',
    fontFamily: "'Google Sans', sans-serif",
    fontWeightStrong: 500,
    lineHeight: 1.5,
    fontSize: 16,
    borderRadius: 8,
    borderRadiusSM: 6,
    controlHeight: 40,
    controlHeightSM: 36,
    controlHeightLG: 44,
    controlPaddingHorizontal: 16,
    controlPaddingHorizontalSM: 12
  },
  components: {
    Button: {
      paddingInlineSM: 12,
      paddingInline: 20,
      paddingInlineLG: 24,
      dangerShadow: 'none',
      defaultShadow: 'none',
      primaryShadow: 'none'
    },
    Menu: {
      subMenuItemBg: 'transparent',
      itemBorderRadius: 8,
      itemMarginInline: 16,
      itemMarginBlock: 8,
      itemHeight: 36,
      itemPaddingInline: 12,
      iconMarginInlineEnd: 8
    },
    Form: {
      verticalLabelPadding: '0 0 4px'
    },
    Tooltip: {
      colorBgSpotlight: '#2B4ACF'
    }
  }
};

export const antdTheme = rootzzTheme;
export const EduzzTheme = rootzzTheme;
